import axios from 'axios'
import log from 'salvo-lite/log'
import Vue from 'vue'
import Helpers from '../helpers/Helpers'

class Search {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._vue = new Vue({
            el: this._elem,
            data: {
                input: '',
                loading: '',
                results: '',
                products: [],
                collections: [],
                form: '',
                resultsFound: false,
                working: false,
                resultsContainer: '',
                submitButton: ''
            },
            mounted: function () {
                this.input = this.$el.querySelector('.search-form__input')
                this.loading = this.$el.querySelector('.search-bar__results-loading')
                this.results = this.$el.querySelector('.search-bar__results-list')
                this.form = this.$el.querySelector('.search-form')
                this.submitButton = this.$el.querySelector('button')
                this.resultsContainer = this.$el.querySelector('.academy-search__form-search-bar__results')
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                }
            },
            methods: {
                newSearch: async function () {
                    this.resultsContainer.classList.remove('visually-hidden')
                    if (window.innerWidth < 600) {
                        this.submitButton.classList.add('visually-hidden')
                    }
                    this.products = []
                    this.collections = []
                    this.resultsFound = false
                    if (this.input.value.length > 0) {
                        this.working = true
                        const results = await this.getResults()
                        await this.sortResults(results)
                    } else {
                        this.collections = []
                        this.products = []
                    }
                },
                sortResults: async function (results) {
                    await this.sortCollections(results.collections)
                    await this.sortProducts(results.products)
                    this.working = false
                },
                sortProducts: async function (products) {
                    let prodDump = []
                    await products.forEach(async product => {
                        if (product.type === 'Course' || product.type === 'course') {
                            if (!this.resultsFound) {
                                this.resultsFound = true
                            }
                            prodDump.push(product)
                        }
                    })
                    this.products = prodDump.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                },
                sortCollections: function (collections) {
                    let colDump = []
                    let ctr = 0
                    collections.forEach(async collection => {
                        const response = await axios.get(collection.url)
                        const collectionPageContent = document.createElement('div')
                        collectionPageContent.innerHTML = response.data
                        if (collectionPageContent.querySelector('.template-collection-educator')) {
                            colDump.push(collection)
                            if (!this.resultsFound) {
                                this.resultsFound = true
                            }
                        }
                        ctr++
                        if (ctr === collections.length) {
                            this.collections = colDump.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
                        }
                    })
                },
                getResults: async function () {
                    const response = await axios.get('/search/suggest.json?q=' + this.input.value + '&resources[type]=product,collection&&resources[options][fields]=title,vendor')
                    return response.data.resources.results
                },
                itemImage: function (src) {
                    return Helpers.getSizedImageUrl(src, '75x75_crop_center')
                },
                submit: function () {
                    if (this.input.value.length > 0) {
                        window.location.href = `/search?type=&q=${this.input.value}`
                    } else {
                        this.input.classList.add('error')
                    }
                },
                close: function () {
                    this.submitButton.classList.remove('visually-hidden')
                    this.input.value = ''
                    this.loading.classList.add('visually-hidden')
                    this.results.classList.add('visually-hidden')
                }
            }
        })
    }
}

export default Search



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Search.js